// /src/store/selectors/sessionSelectors.ts
import { RootState } from '@/store/store';

export const selectSessionData = (state: RootState) => state.session.data;
export const selectSessionType = (state: RootState) => state.session.data.sessionType;
export const selectSessionLoading = (state: RootState) => state.session.loading;
export const selectSessionError = (state: RootState) => state.session.error;
